import { render, staticRenderFns } from "./My.vue?vue&type=template&id=2ba2ec84&scoped=true&"
import script from "./My.vue?vue&type=script&lang=ts&"
export * from "./My.vue?vue&type=script&lang=ts&"
import style0 from "./My.vue?vue&type=style&index=0&id=2ba2ec84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba2ec84",
  null
  
)

export default component.exports